import Cookies from 'js-cookie';
import L from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const maptilerKey = 'spa73VWIuAalBso5UJT9';
const BaseMapLayerControl: React.FC = () => {
  const map = useMap();

  useEffect(() => {
    // Define Base Layers
    const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '© OpenStreetMap contributors',
    });

    const satellite = L.tileLayer(`https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${maptilerKey}`, {
      maxZoom: 19,
      attribution: '© OpenStreetMap contributors',
    });

    // Base layers object
    const baseMaps = {
      OpenStreetMap: osm,
      Satellite: satellite,
    };

    // Define valid layer names
    type LayerName = 'OpenStreetMap' | 'Satellite';

    // Get saved layer from cookie or default to 'OpenStreetMap'
    const savedLayerName = (Cookies.get('selectedMapLayer') || 'OpenStreetMap') as LayerName;
    const defaultLayer = baseMaps[savedLayerName] || osm;

    // Add the saved/default layer to the map
    defaultLayer.addTo(map);

    // Create and add Layers Control
    const layerControl = L.control.layers(baseMaps, {}, { position: 'topleft' }).addTo(map);

    // Listen for layer change events and save to cookie
    map.on('baselayerchange', (e) => {
      const selectedLayerName = e.name;
      Cookies.set('selectedMapLayer', selectedLayerName, { expires: 365 });
    });

    // Cleanup on unmount
    return () => {
      layerControl.remove();
      map.off('baselayerchange');
    };
  }, [map]);

  return null;
};

export default BaseMapLayerControl;
